import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { useTheme } from '@mui/styles';
import { ButtonBase, Link, Tooltip } from '@mui/material';

// project imports
import Avatar from './../extended/Avatar';

//-----------------------|| CARD SECONDARY ACTION ||-----------------------//

const CardSecondaryAction = ({ title, link, icon }) => {
    const theme = useTheme();

    return (
        <Tooltip title={title ? title : 'Reference'} placement="left">
            <ButtonBase disableRipple>


            </ButtonBase>
        </Tooltip>
    );
};

CardSecondaryAction.propTypes = {
    icon: PropTypes.node,
    link: PropTypes.string,
    title: PropTypes.string
};

export default CardSecondaryAction;
